import { SHOW_ALERT_HEADER } from '../../actions/musica/music-actions';

const initialState = {
    activeBelt : false
};

const flagAlertBelt = (state, action) => {
    return {
      ...state,
      activeBelt: !state.activeBelt
    }
  };

  function reducer(state = initialState, action = {}) {
    switch (action.type) {
      case SHOW_ALERT_HEADER:
        return flagAlertBelt(state, action);
      default:
        return state;
    }
  }
  
export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/musica/alert-header-reducer.js